import { useState } from 'react';
import { useProductsDetailed } from '../productsDetailedContext'
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { formatMoney } from '../../../../../../Utils/formatMoney'
import { FormatMoney } from '../../../formatMoney'
import { TiPlus, TiMinus, TiEquals } from 'react-icons/ti'
import { FiMoreVertical } from 'react-icons/fi'
import { download_csv } from '../../JsonToCsv'
import { ExportFiles } from '../../ExportFiles'
import { useSelector } from 'react-redux'
import { api } from '../../../../../../services/api'

import { toast } from 'react-toastify';
import { Container, Content, Groups, TotalValue, TableProducts, ContainerLoading,Button } from './style';

export function ProductsIncome() {
    const productsDatas = useSelector(state => state.modalCentralized.datasComponent)
    const { isLoading,setIsLoading, allProductsDatas, dateToCsvDownload, fetchData, loadingButton, page,totalDelivery, totalDescont, totalProducts } = useProductsDetailed()

    const [isOpen, setIsOpen] = useState(false);

    async function handleDownloadCSV() {
        setIsLoading(true);
        try{
            const response = await api.post('/getResumeProductsNew',
            {
                data:{
                    business:  productsDatas.business,
                    endDate:  productsDatas.endDate,
                    salesChannels:  productsDatas.salesChannels,
                    startDate:  productsDatas.startDate,
                    type: 'excel'
                }
            }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
        
            const newArr = response.data.datas.map((data) => {
                return{
                    Codigo: data.cdEmpresa,
                    Id_Customizado: data.idCustomized,
                    CNPJ: data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                    Empresa: data.dsEmpresa,
                    Numero_Venda: data.nrOrcamento,
                    idGrupo: data.cdGrupo,
                    Grupo: data.dsGrupo,
                    idProduto: data.cdProduto,
                    Produto: data.dsProduto,
                    Preco: Number(data.preco).toFixed(2).replace('.',','),
                    Quantidade: data.nrQtd,
                    Desconto: Number(data.descont).toFixed(2).replace('.',','),
                    Total: Number(data.total).toFixed(2).replace('.',',')                    
                }
            })
            download_csv(newArr,dateToCsvDownload)
            setIsLoading(false);
        }
        catch(error){
            toast.error('Ops, algo deu errado')
            setIsLoading(false);
        }
        // setIsLoading(false)
    }

    // function handleDownloadCSV() {
    //     let arrayProducts = []
    //     let newArray = []

    //     allProductsDatas.groups.map(gp => (
    //         arrayProducts = arrayProducts.concat(gp.products)
    //     ))

    //     arrayProducts.map(product => (
    //         newArray.push({...product, total: product.total.toLocaleString('pt-BR')})
    //     ))

    //     const arr = newArray.map((data) => {
    //         return{
    //             Codigo: data.id,
    //             Produto: data.name,
    //             Numero_Venda: data.nrOrcamento,
    //             Qtd: data.qtd,
    //             Total: data.total,
    //             Desconto: Number(data.discount).toFixed(2).replace('.',','),
    //             Preço: Number(data.price).toFixed(2).replace('.',','),
    //             Grupo: data.group_name
    //         }
    //     })
    //     console.log(arr)
    //     download_csv(arr, dateToCsvDownload)
    // }


    if (isLoading) {

        return (
            <ContainerLoading>

                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />

            </ContainerLoading>
        )

    } else {
        return (
            <Container>

                <div className="seeMore">
                    <FiMoreVertical
                        onClick={() => setIsOpen(!isOpen)}
                    />

                    <ExportFiles
                        handleDownloadCSV={handleDownloadCSV}
                        setIsOpen={setIsOpen}
                        isOpen={isOpen}
                    />
                </div>


                <Content>
                    {
                        allProductsDatas.map((group) => {
                            return(
                                <Groups key={group.name}>
                                    <h3>&#8226;{group.name}</h3>

                                    <TableProducts>
                                        <thead>
                                            <tr>
                                                <th>Produto</th>
                                                <th>Preço</th>
                                                <th>Qtd</th>
                                                <th>Desc</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                group.children.map((item) => {
                                                    return(
                                                        <tr key={item.cdProduto}>
                                                            <td>{item.dsProduto}</td>
                                                            <td>{formatMoney(item.preco)}</td>
                                                            <td>{item.nrQtd}</td>
                                                            <td className={item.descont > 0 && 'discount'}>{formatMoney(item.descont)}</td>
                                                            <td>{formatMoney(item.total)}</td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                            <tr>
                                                <td>Total: </td>
                                                <td></td>
                                                <td>
                                                    {
                                                        group.children.map((item) => {
                                                            return item.nrQtd
                                                        })
                                                        .reduce((value, next) => {
                                                            return value + next
                                                        })
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        formatMoney(
                                                            group.children.map((item) => {
                                                                return item.descont
                                                            })
                                                            .reduce((value, next) => {
                                                                return value + next
                                                            })
                                                        )
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        formatMoney(
                                                            group.children.map((item) => {
                                                                return item.total
                                                            })
                                                            .reduce((value, next) => {
                                                                return value + next
                                                            })
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </TableProducts>
                                </Groups>
                            )
                        })
                    }
                    {
                         page !== null &&
                         <Button onClick={fetchData} loadingButton={loadingButton}>
                         {
                             loadingButton ? 
                             '...aguarde'
                             :
                             'Ver mais'
                         }
                        </Button>
                    }
                </Content>


                <TotalValue>

                    <div className="blue">
                        <span>Produtos</span>

                        <FormatMoney 
                            value={totalProducts} 
                        />
                    </div>

                    <TiPlus />

                    <div className="blue">
                        <span>Entrega</span>

                        <FormatMoney 
                            value={totalDelivery} 
                        />
                    </div>

                    <TiMinus />

                    <div className="red">
                        <span>Desconto</span>

                        <FormatMoney value={totalDescont} />
                    </div>

                    <TiEquals />

                    <div className="green">
                        <span>Total</span>

                        {/* <FormatMoney value={(totalProducts + totalDelivery) - totalDescont} /> */}
                        <FormatMoney value={(totalProducts + totalDelivery) - totalDescont } />
                    </div>

                </TotalValue>
            </Container>    
        )
    }

}

